<div class="video-container">
    <iframe 
      width="560" 
      height="315" 
      src="{{ videoSource }}" 
      frameborder="0" 
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
      allowfullscreen>
    </iframe>
</div>